import Stocks from './Stocks';

export default Stocks;
